<template>
  <md-content class="md-elevation-2 cta-content" data-cy="refer-cta">
      <img src="/img/send-points.png" alt="Send points image"/>
      <div @click="ctaClick()">
        <SButtonMaterial
          buttonType="button"
          class="btn-size"
          color="primary"
          textColor="white"
          materialClass="dense"
          @button="$emit('register')"
          text="Send points"
          iconLeftText="send"
          iconColor="white"
          :data-cy="`${dataCy}-btn`"
          />
      </div>
      <span class="send-points-text">Send points directly to another user if you have negotiated a price different from that established on the item</span>
  </md-content>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "SendPointsCTA",
  components: {
    SButtonMaterial
  },
  methods: {
    ctaClick() {
      this.$emit("sendPointsCTAButton")
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-content {
  width: 100%;
  max-width: 340px;
  min-width: 250px;
  height: fit-content;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 15px;
  padding: 15px;
}
.send-points-text {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 1.25px;
  color: rgba(18, 18, 18, 0.68);
}

</style>
